module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_3.182534ff.png";